<template>
    <v-list-group
        v-if="item.items && hasVisibleSubitems"
        :key="item.title"
        v-model="item.active"
        :group="item.group"
        no-action
        color="white"
        :sub-group="isSubGroup"
        active-class="accent"
    >
        <template v-slot:prependIcon>
            <v-icon small>{{ item.icon }}</v-icon>
        </template>

        <template v-slot:activator>
            <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
        </template>

        <template v-slot:appendIcon>
            <v-icon small>mdi-chevron-down</v-icon>
        </template>

        <template v-for="subitem in item.items">
            <navigation-item v-if="!subitem.items" :key="item.title + '-' + subitem.title" :item="subitem" />
            <navigation-group v-if="subitem.items" :key="item.title + '-' + subitem.title" :item="subitem" isSubGroup />
        </template>
    </v-list-group>
</template>

<script>
import NavigationItem from "@/components/Layout/Partials/NavigationItem";
import User from "@/models/User/User";
export default {
    name: 'navigation-group',
    components: {NavigationItem},
    props: {
        item: {
            required: true,
            type: Object,
        },
        isSubGroup: {
            required: false,
            type: Boolean,
            default: false,
        }
    },
    computed: {
        hasVisibleSubitems() {
            return this.item.items.some(subitem => !subitem.permission || User.loggedInUser().HasPermission(subitem.permission))
        },
    },
}
</script>
